
import React from "react";
import Header from "../shared/Header";
import Footer from "../shared/Footer";
import { i18nManager } from "../../i18n";
import Breadcrumb from "../shared/Breadcrumb";
import * as ReactRouterDom from "react-router-dom";
import { CacheManager, Debugger, Utils } from "../../utils";
import { SupportResourceService, ISupportResource, SanitizedResponse } from "../../services";

function Resources() {
    const labels = i18nManager.Labels.contact;
    const { platform } = ReactRouterDom.useParams();
    const activePlatform = CacheManager.getPlatform(platform);
    const supportResourceService = SupportResourceService.getInstance();
    const [supportResources, setSupportResources] = React.useState<{ video_resources: ISupportResource[]; article_resources: ISupportResource[]; document_resources: ISupportResource[]; }>({} as any);

    React.useEffect(() => {
        if (!activePlatform) return;
        supportResourceService.querySupportResources({ sort: "id,DESC", "platform.external_id": activePlatform?.external_id, size: 100 }).then(({ sanitized }: SanitizedResponse<any>) => {
            Debugger.log("Resources:useEffect:querySupportResources", sanitized.document_resources);
            setSupportResources(sanitized);
        }).catch((error: SanitizedResponse<any>) => {
            Utils.reportError(error);
        });
    }, []);

    return (<div className="support">
        <Header title={labels.title} />
        <Breadcrumb breadCrumbs={[{ label: labels.title, location: `/${platform}/contact-us` }, { label: labels.resources, location: window.location.href }]} />
        <div className="resources">
            {supportResources.video_resources?.length > 0 && (<div className="video">
                <span className="title">{labels.videos}</span>
                <div>
                    {supportResources.video_resources?.map((resource, index) => (<div key={resource.description + index}>
                        <video controls>
                            <source src={resource.url_location} type="video/mp4" />
                            Your browser does not support the video tag.
                        </video>
                        <span>{resource.description}</span>
                    </div>))}
                </div>
            </div>)}
            {supportResources.article_resources?.length > 0 && (<div className="articles">
                <span className="title">{labels.articles}</span>
                <div>
                    {supportResources.article_resources?.map((resource, index) => (<div key={resource.description + index}>
                        <span>{resource.description}</span>
                        <a target="_blank" rel="noreferrer" href={resource.url_location}>{resource.url_location}</a>
                    </div>))}
                </div>
            </div>)}
            {supportResources.document_resources?.length > 0 && (<div className="documents">
                <span className="title">{labels.documents}</span>
                <div>
                    {supportResources.document_resources?.map((resource, index) => (<div key={resource.description + index}>
                        <span>{resource.description}</span>
                        <a target="_blank" rel="noreferrer" href={resource.url_location}>{resource.url_location}</a>
                    </div>))}
                </div>
            </div>)}
        </div>
        <Footer />
    </div>);

}

export default Resources;
